// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"60bcbd4e","453":"b23a39a9"}[chunkId] + ".chunk.js";
};